(() => {
  const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const addUrl = rootPath + 'cart/add.js';

  function getDrawer() { return document.querySelector('cart-drawer'); }

  async function getCartState() {
    const stamp = Date.now();
    const response = await fetch(rootPath + 'cart.js?_kravos=' + stamp, {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' }
    });
    if (!response.ok) throw new Error('Cart state request failed');
    return response.json();
  }

  async function refreshCartIcon() {
    const stamp = Date.now();
    const response = await fetch(rootPath + 'cart?section_id=cart-icon-bubble&_kravos=' + stamp, {
      cache: 'no-store',
      credentials: 'same-origin',
      headers: { Accept: 'text/html', 'Cache-Control': 'no-cache' }
    });
    if (!response.ok) return;
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshBubble = doc.querySelector('#cart-icon-bubble');
    const currentBubble = document.querySelector('#cart-icon-bubble');
    if (freshBubble && currentBubble) currentBubble.replaceWith(freshBubble);
  }

  async function refreshDrawer(options = {}) {
    const drawer = getDrawer();
    if (!drawer) throw new Error('Cart drawer not found');

    // Fetch the drawer section and cart state in parallel. The drawer itself
    // can remain open while these requests hydrate the latest markup.
    const stamp = Date.now();
    const sectionPromise = fetch(rootPath + 'cart?section_id=cart-drawer&_kravos=' + stamp, {
      cache: 'no-store', credentials: 'same-origin',
      headers: { Accept: 'text/html', 'Cache-Control': 'no-cache' }
    });
    const cartPromise = getCartState();
    const [response, cartState] = await Promise.all([sectionPromise, cartPromise]);
    if (!response.ok) throw new Error('Cart drawer section refresh failed');

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshDrawer = doc.querySelector('cart-drawer');
    if (!freshDrawer) throw new Error('Fresh cart drawer markup not found');

    // Keep the persistent WhatsApp node outside before replacing the drawer HTML.
    restoreFloatingWhatsApp();
    drawer.innerHTML = freshDrawer.innerHTML;
    const hasItems = Number(cartState.item_count || 0) > 0;
    drawer.classList.toggle('is-empty', !hasItems);
    const drawerItems = drawer.querySelector('cart-drawer-items');
    if (drawerItems) drawerItems.classList.toggle('is-empty', !hasItems);
    const emptyInner = drawer.querySelector('.drawer__inner-empty');
    const normalInner = drawer.querySelector('.drawer__inner');
    if (emptyInner) emptyInner.hidden = hasItems;
    if (normalInner) normalInner.hidden = !hasItems;
    const checkout = drawer.querySelector('#CartDrawer-Checkout');
    if (checkout) {
      checkout.disabled = !hasItems;
      checkout.toggleAttribute('disabled', !hasItems);
    }

    bindDrawerWhatsApp(drawer);
    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', () => drawer.close(), { once: true });

    // Icon refresh is deliberately non-blocking: it must never delay drawer UX.
    refreshCartIcon().catch(() => {});
    if (options.open !== false && typeof drawer.open === 'function') drawer.open();
    return cartState;
  }

  function getWhatsApp() {
    return document.querySelector('.kravos-whatsapp-float');
  }

  function bindDrawerWhatsApp(drawer) {
    const wa = getWhatsApp();
    const slot = drawer?.querySelector('[data-kravos-wa-slot]');
    if (!wa || !slot) return;
    if (wa.parentElement !== slot) slot.appendChild(wa);
    wa.classList.add('kravos-whatsapp-in-drawer');
    wa.dataset.kravosInDrawer = 'true';
    wa.style.visibility = 'visible';
    wa.style.pointerEvents = 'auto';
  }

  function restoreFloatingWhatsApp() {
    const wa = getWhatsApp();
    if (!wa) return;
    if (wa.dataset.kravosInDrawer !== 'true') return;
    document.body.appendChild(wa);
    wa.classList.remove('kravos-whatsapp-in-drawer');
    wa.dataset.kravosInDrawer = 'false';
    wa.style.visibility = '';
    wa.style.pointerEvents = '';
  }

  document.addEventListener('click', function(event) {
    const close = event.target.closest && event.target.closest('.cart-drawer .drawer__close, #CartDrawer-Overlay');
    if (close) {
      window.setTimeout(() => {
        const drawer = getDrawer();
        if (!drawer || !drawer.classList.contains('active')) restoreFloatingWhatsApp();
      }, 220);
    }
  }, true);

  // V56: move WhatsApp into the drawer as soon as the drawer becomes active.
  // This is independent of cart hydration, so the support button never floats
  // over the drawer while Shopify is updating its contents.
  function syncWhatsAppWithDrawer() {
    const drawer = getDrawer();
    if (!drawer) return;
    if (drawer.classList.contains('active')) bindDrawerWhatsApp(drawer);
    else restoreFloatingWhatsApp();
  }

  function watchDrawerState() {
    const drawer = getDrawer();
    if (!drawer || drawer.dataset.kravosWaObserver === 'true') return;
    drawer.dataset.kravosWaObserver = 'true';
    const observer = new MutationObserver(syncWhatsAppWithDrawer);
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    syncWhatsAppWithDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawerState, { once: true });
  } else {
    watchDrawerState();
  }

  // Shared API for popup / AOV widgets to use the exact same drawer refresh path.
  window.KravosRefreshCartDrawer = refreshDrawer;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => bindDrawerWhatsApp(getDrawer()), { once: true });
  } else {
    bindDrawerWhatsApp(getDrawer());
  }

  // KRAVOS: every normal cart link opens the drawer instead of navigating to /cart.
  // The native #cart-icon-bubble handler already does this, so we leave that link alone.
  document.addEventListener('click', function(event) {
    const anchor = event.target.closest && event.target.closest('a[href]');
    if (!anchor || anchor.id === 'cart-icon-bubble') return;
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    let url;
    try { url = new URL(anchor.href, window.location.href); } catch (_) { return; }
    const cartPath = new URL((window.routes && window.routes.cart_url) || rootPath + 'cart', window.location.origin).pathname.replace(/\/$/, '');
    const targetPath = url.pathname.replace(/\/$/, '');
    if (targetPath !== cartPath) return;

    const drawer = getDrawer();
    if (!drawer || typeof drawer.open !== 'function') return;

    event.preventDefault();
    // Instant visual response; never wait for the section request before opening.
    try { drawer.open(anchor); } catch (_) {}
    refreshDrawer({ open: false }).catch(function(error) {
      console.error('KRAVOS cart-link drawer open:', error);
      // Never redirect to /cart from a cart link while the drawer exists.
      try { drawer.open(); } catch (_) {}
    });
  }, true);

  async function addVariant(variantId, button) {
    button.classList.add('is-loading');
    button.disabled = true;
    const drawer = getDrawer();
    if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (_) {} }
    try {
      const payload = { items: [{ id: Number(variantId), quantity: 1 }] };
      const response = await fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || 'Unable to add product');
      }
      refreshDrawer({ open: false }).catch((error) => console.error('KRAVOS drawer hydration:', error));
      button.classList.remove('is-loading');
      button.disabled = false;
      button.innerHTML = '<span>✓ ADDED</span>';
      setTimeout(() => {
        button.innerHTML = '<span>+ ADD</span>';
      }, 1600);
    } catch (error) {
      console.error('KRAVOS cart add:', error);
      button.classList.remove('is-loading');
      button.disabled = false;
      button.innerHTML = '<span>TRY AGAIN</span>';
      setTimeout(() => button.innerHTML = '<span>+ ADD</span>', 1800);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-kravos-cart-add]');
    if (!button) return;
    event.preventDefault();
    addVariant(button.getAttribute('data-variant-id'), button);
  });
})();

// KRAVOS: keep product-card / AOV add buttons in sync with the live cart.
(() => {
  'use strict';
  const rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const addButtonSelector = '[data-kravos-product-id], [data-kravos-cart-add][data-variant-id]';
  let syncing = false;
  let queued = false;

  function setButtonState(button, added) {
    if (!button) return;
    if (button.dataset.kravosAdded === String(added)) return;
    button.dataset.kravosAdded = String(added);
    button.classList.toggle('is-added', added);
    button.classList.toggle('kravos-is-added', added);
    if (button.matches('[data-kravos-cart-add]')) {
      button.innerHTML = added ? '<span>✓ ADDED</span>' : '<span>+ ADD</span>';
      button.disabled = !!added;
      button.setAttribute('aria-pressed', String(added));
      return;
    }
    const label = button.querySelector('.kravos-add-label') || button.querySelector(':scope > span:not(.sold-out-message)') || button.querySelector('span');
    if (label) {
      if (!button.dataset.kravosOriginalLabel) button.dataset.kravosOriginalLabel = label.textContent.trim();
      label.textContent = added ? '✓ ADDED' : button.dataset.kravosOriginalLabel;
    }
    button.disabled = added || button.dataset.wasDisabled === 'true';
    button.setAttribute('aria-pressed', String(added));
  }

  function scheduleSync(delay = 250) {
    if (queued) return;
    queued = true;
    window.setTimeout(() => {
      queued = false;
      syncCartButtons();
    }, delay);
  }

  async function syncCartButtons() {
    if (syncing) return;
    const buttons = Array.from(document.querySelectorAll(addButtonSelector));
    if (!buttons.length) return;
    syncing = true;
    try {
      const response = await fetch(rootPath + 'cart.js?_kravos_button_sync=' + Date.now(), {
        cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json', 'Cache-Control': 'no-cache' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      const productIds = new Set((cart.items || []).map(item => String(item.product_id)));
      const variantIds = new Set((cart.items || []).map(item => String(item.variant_id)));
      buttons.forEach(button => {
        const productId = button.getAttribute('data-kravos-product-id');
        const variantId = button.getAttribute('data-kravos-variant-id') || button.getAttribute('data-variant-id');
        const added = (variantId && variantIds.has(String(variantId))) || (productId && productIds.has(String(productId)));
        setButtonState(button, !!added);
      });
    } catch (error) {
      console.debug('KRAVOS button sync:', error);
    } finally {
      syncing = false;
    }
  }

  // Initial state + navigation restore.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scheduleSync(0), { once: true });
  else scheduleSync(0);
  window.addEventListener('pageshow', () => scheduleSync(80));
  document.addEventListener('visibilitychange', () => { if (!document.hidden) scheduleSync(80); });

  // Shopify's cart mutations and our custom drawer/AOV code both expose change points.
  document.addEventListener('cart:updated', () => scheduleSync(180));
  document.addEventListener('shopify:section:load', () => scheduleSync(200));

  // Lightweight interaction hooks — no MutationObserver on the whole document.
  document.addEventListener('click', (event) => {
    if (event.target.closest(addButtonSelector)) scheduleSync(900);
    if (event.target.closest('.cart-remove-button, cart-remove-button, .quantity__button[name="minus"], .quantity__button[name="plus"]')) scheduleSync(900);
  }, { passive: true });
  document.addEventListener('change', (event) => {
    if (event.target.closest('.quantity__input')) scheduleSync(900);
  }, { passive: true });

  // AOV/popup code can use this hook after async cart updates.
  window.KravosSyncCartButtons = syncCartButtons;
})();
